<template>
  <div v-if="role === 'senior-retoucher'"  class="uk-width-auto uk-text-right">
    <div class="tm-order-count uk-box-shadow-medium tm-order-count-senior">
      <div>
        {{ count_today }}/{{ count_week }}/{{ count_month }}
      </div>
      <div class="uk-dropdown tm-dropdown tm-dropdown-left-top" data-uk-dropdown="animation: uk-animation-slide-top-small; pos: left-top; delay-hide: 500; delay-show: 0; offset: 20">
        {{ local_page_keys.senior_order_count_disc }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdersStatSenior",
  props: {
    local_page_keys: {
      type: Object,
      require: true
    },
    role: {
      type: String,
      require: true,
    }
  },
  data: () => ({
    count_today: 0,
    count_week: 0,
    count_month: 0
  }),
  methods: {
    async fetchOrdersStatSenior() {
      let data;
      await this.$store.dispatch('order/ordersStatSenior');
      data = await this.$store.getters['order/ordersStatSenior'];

      if (data) {
        this.count_today = data.today;
        this.count_week = data.week;
        this.count_month = data.month;
      }
    },

  },
  async mounted() {
    await this.fetchOrdersStatSenior();
  },
}
</script>
